module.exports = __webpack_public_path__ + "img/header-banner-1229.f1b3747a.png";